import script from "./SpiderChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SpiderChart.vue?vue&type=script&setup=true&lang=js"

import "./SpiderChart.vue?vue&type=style&index=0&id=77ced264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ced264"]])

export default __exports__